function mapGetListCollateralTemplateSuggestionsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetListCollateralTemplateSuggestionsData };
